import {CSSProperties} from "react";
import {BLACK} from "../../../../styles/colors";

const iconStyle: CSSProperties = {
  width: '16px',
  height: '16px',
  color: BLACK,
}

export const styles = {
  Icon: iconStyle,
}